import Vue from 'vue'
import VueRouter from 'vue-router'
import { requiresError, checkOverridden } from '@/middleware/router-guards'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'DefaultPage',
    component: () => import(/* webpackChunkName: "defaultPage" */ './views/page')
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import(/* webpackChunkName: "error" */ './views/error'),
    beforeEnter: requiresError
  },
  {
    path: '/languages/:lang?',
    name: 'Languages',
    component: () => import(/* webpackChunkName: "languages" */ './views/languages')
  },
  {
    path: ':group/languages/:lang?',
    name: 'Languages',
    component: () => import(/* webpackChunkName: "languages" */ './views/languages')
  },
  {
    path: '/:name',
    name: 'Page',
    component: () => import(/* webpackChunkName: "page" */ './views/page')
  },
  {
    path: '/:group/:name',
    name: 'Page',
    component: () => import(/* webpackChunkName: "page" */ './views/page')
  },
  {
    path: '/events/detail/:id',
    name: 'Event Details',
    component: () => import(/* webpackChunkName: "event-details" */ './views/event-details')
  },
  /*
  overrides go below
  */
  {
    path: '/COVID',
    name: 'Page',
    component: () => import(/* webpackChunkName: "languages" */ './views/page')
  },
  {
    path: '/find-a-doc',
    name: 'Page',
    component: () => import(/* webpackChunkName: "languages" */ './views/page')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.beforeEach(checkOverridden)

export default router
